import { FunctionComponent, useState } from 'react';

import { InputLabel } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import LightTheme from '../../../themes/LightTheme';
import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledUserContainer, StyledRowItemsLeftJustContainer, StyledRowItemsRightJustContainer } from '../styles/styled-components';
import MoveUser from './MoveUser';
import UserImage from './UserImage';

interface BreakoutUserRowProps {
    name: string;
    id: string;
    imgSource?: string;
    inBreakoutRoom: boolean;
}

const UserLabel = withStyles(() => ({
    root: {
        color: LightTheme.colors.black,
        lineHeight: '24px',
        fontSize: '16px',
        textAlign: 'left'
    }
}))(InputLabel);

const JoinStatusLabel = withStyles(() => ({
    root: {
        color: LightTheme.colors.error,
        lineHeight: '24px',
        fontSize: '12px',
        textAlign: 'left',
        paddingLeft: '5px'
    }
}))(InputLabel);

const BreakoutUserRowItem: FunctionComponent<BreakoutUserRowProps> = ({ name, id, imgSource, inBreakoutRoom }) => {
    const [showMoveButton, setShowMoveButton] = useState(false);
    const { isCreator } = useContainer(BreakoutRoomOptionsContainer);
    const { t } = useTranslation('breakout_room');

    const handleMouseEnter = () => {
        setShowMoveButton(isCreator);
    };

    const handleMouseLeave = () => {
        setShowMoveButton(false);
    };

    return (
        <StyledUserContainer key={id} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <StyledRowItemsLeftJustContainer>
                <UserImage imgSource={imgSource} name={name} />
                <UserLabel>{name}</UserLabel>
                {!inBreakoutRoom && <JoinStatusLabel>{t('has-not-joined')}</JoinStatusLabel>}
            </StyledRowItemsLeftJustContainer>
            <StyledRowItemsRightJustContainer>
                {showMoveButton && <MoveUser userId={id} inBreakoutRoom={inBreakoutRoom} />}
            </StyledRowItemsRightJustContainer>
        </StyledUserContainer>
    );
};
export default BreakoutUserRowItem;
